import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=6627b52d&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=ts&"
export * from "./Client.vue?vue&type=script&lang=ts&"
import style0 from "./Client.vue?vue&type=style&index=0&id=6627b52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6627b52d",
  null
  
)

export default component.exports